import React from "react";
import { CardSizeType } from "web/react/components/membership-promo-overlay";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import * as styles from "./review-card.css";

type ReviewDataType = {
    id: number;
    initials: string;
    rating: number;
    snippet: string;
};

interface ReviewCardProps {
    review: ReviewDataType;
    variant: CardSizeType;
}
export function ReviewCard({ review, variant }: ReviewCardProps): React.ReactElement {
    const stars = (): React.ReactElement[] => {
        let arr: React.ReactElement[] = [];
        for (let i = 0; i < review.rating; i++) {
            arr.push(<SVGIcon key={i} className={styles.star[variant]} name="emo-star" />);
        }
        return arr;
    };
    return (
        <div className={styles.card[variant]}>
            <div className={styles.profile[variant]}>
                <div className={styles.avatar[variant]}>{review.initials}</div>
                <div className={styles.stars[variant]}>{stars()}</div>
            </div>
            <div className={styles.content[variant]}>{review.snippet}</div>
        </div>
    );
}
